export const FOOD_LIBRARY = {
  protein: [
    { name: "Chicken Breast", amount: "150g", cal: 248, tip: "Highest protein-to-calorie ratio." },
    { name: "Greek Yogurt (0%)", amount: "200g", cal: 120, tip: "Great for casein-based slow digestion." },
    { name: "Liquid Egg Whites", amount: "250g", cal: 130, tip: "Pure protein with zero fat or carbs." },
    { name: "Tofu (Firm)", amount: "150g", cal: 125, tip: "Excellent plant-based complete protein." },
    { name: "Whey Isolate", amount: "1 scoop", cal: 110, tip: "Fastest absorbing post-workout fuel." },
    { name: "White Fish (Cod)", amount: "150g", cal: 123, tip: "Leanest animal protein source available." }
  ],
  carbs: [
    { name: "Oats (Dry)", amount: "50g", cal: 190, tip: "Low GI for sustained energy release." },
    { name: "Sweet Potato", amount: "200g", cal: 172, tip: "Packed with Vitamin A and fiber." },
    { name: "Brown Rice (Cooked)", amount: "150g", cal: 165, tip: "Complex carb for glycogen replenishment." },
    { name: "Blueberries", amount: "150g", cal: 85, tip: "High antioxidant, low calorie density." },
    { name: "Quinoa (Cooked)", amount: "150g", cal: 180, tip: "Contains all nine essential amino acids." },
    { name: "Banana", amount: "1 medium", cal: 105, tip: "Quick potassium-rich pre-workout energy." }
  ],
  fat: [
    { name: "Avocado", amount: "1/2 medium", cal: 160, tip: "Heart-healthy monounsaturated fats." },
    { name: "Almonds", amount: "20g", cal: 115, tip: "Rich in Vitamin E and mineral density." },
    { name: "Extra Virgin Olive Oil", amount: "1 tbsp", cal: 120, tip: "Best for lowering systemic inflammation." },
    { name: "Peanut Butter", amount: "1 tbsp", cal: 95, tip: "Energy dense; monitor serving sizes closely." },
    { name: "Chia Seeds", amount: "15g", cal: 73, tip: "High Omega-3 and soluble fiber content." }
  ]
};